import React from "react"
import classnames from "classnames"
import styles from "./Visible.less"


class Visible extends React.PureComponent {

  render() {
    const {
      children, visible = ["screen","tablet","mobile"]
    } = this.props

    return (
      <div
        className={classnames({
          [styles.Visible]: visible,
          [styles.VisibleScreen]: visible.includes("screen"),
          [styles.VisibleTablet]: visible.includes("tablet"),
          [styles.VisibleMobile]: visible.includes("mobile")
        })}
      >
        {children}
      </div>
    )
  }
}


export default Visible



// WEBPACK FOOTER //
// ./src/AtomicComponents/Visible/Visible.jsx